export default __webpack_public_path__ + "static/media/Cancel.5f574180.gif";